/** Injected from package.json at build time (see vue.config.js). */
export const APP_VERSION = process.env.VUE_APP_VERSION || '1.2.0';

/** User-facing label, e.g. "1.2" from semver "1.2.0". */
export function formatAppVersionLabel(version = APP_VERSION) {
  const normalized = String(version).trim();
  if (!normalized) return '1.2';

  const parts = normalized.split('.');
  if (parts.length >= 2 && (parts[2] === '0' || parts[2] === '')) {
    return `${parts[0]}.${parts[1]}`;
  }

  return normalized;
}
